"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(src) {
  var moreAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var script = document.createElement('script');
  var attrs = (0, _extends2.default)({
    async: true
  }, moreAttrs, {
    src: src
  });
  Object.keys(attrs).forEach(function (key) {
    script.setAttribute(key, attrs[key]);
  });
  document.body.appendChild(script);
};

exports.default = _default;
module.exports = exports.default;